import { LicenseInfo } from '@mui/x-license-pro';

const applyKeyMUI = () => {   
     LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_KEY);
}

export {
    applyKeyMUI
}